import Vue from 'vue'
import Vuex from 'Vuex'
import Axios from 'axios'
import Router from './router'
Vue.use(Vuex)

function loader(promise,target){
  const container = document.querySelector(target);
  const loaderDiv = document.createElement('div');
  const spinner = document.createElement('span');
  const parent = container.parentNode;
  loaderDiv.classList.add('loading');
  loaderDiv.append(spinner);
  parent.prepend(loaderDiv);
  const colors = [
    'rgb('+getComputedStyle(document.documentElement).getPropertyValue('--dgray')+')',
    'rgb('+getComputedStyle(document.documentElement).getPropertyValue('--yellow')+')',
    'rgb('+getComputedStyle(document.documentElement).getPropertyValue('--red')+')',
    'rgb(0,0,0)'

  ];
  const borders = [
    'borderTopRightRadius',
    'borderBottomRightRadius',
    'borderBottomLeftRadius',
    'borderTopLeftRadius'
  ]
  let counter = 0;
  setInterval(()=>{
    if(counter === 4) {
      counter = 0;
    }
    spinner.style.background = colors[Math.floor(Math.random()*3)];
    spinner.style.borderRadius = '50%';
    spinner.style[borders[counter]] = '0';
    counter++;
  },200)
  promise.then((res)=>{
    setTimeout(()=>{
      loaderDiv.style.opacity = '0';
      setTimeout(()=>{
        loaderDiv.remove();
      },200)
    },400)
  })
}

export default new Vuex.Store({
  state: {
    posts: {
      all: [],
      prosa: [],
      poesia: [],
      search: []
    },
    postsSelected: '',
    pagesTotal: {
      all: '',
      prosa: '',
      poesia: '',
      search: ''
    },
    pagesCurr:  '',
    searchTerm: ''
  },
  mutations: {
    setPosts(state,[type,data]) {
      if(!data) {
        state.posts[type] = state.posts[type]
      }
      else {
        Vue.set(state.posts[type], state.pagesCurr,data);
      }
    },
    resetPosts(state,type) {
      Vue.set(state.posts, type,[]);
    },
    setPostsSelected(state,data) {
      Vue.set(state,'postsSelected',data);
    },
    setPagesTotal(state,[type,data]) {
      state.pagesTotal[type] = data
    },
    setPagesCurr(state,data) {
      Vue.set(state,'pagesCurr',data);
    },
    setSearchTerm(state,data) {
      Vue.set(state,'searchTerm',data);
    },
    clearSearch(state) {
      Vue.set(state,'searchTerm','');
    }
  },
  actions: {
    setSearch({commit,dispatch},term) {
      commit('setSearchTerm',term);
      dispatch('postsSearch',term);
    },
    postsSearch({commit},term) {
      let endpoint;
      if(term.search('autor:')>-1) {
        endpoint = '?filter[author_name]='+term.split(':')[1].trim();
      }
      else {
        endpoint = '?search='+term;
      }
      commit('resetPosts','search');
      Axios.get('http://ecos.ec/wp-json/wp/v2/posts/'+endpoint).then(res=>{
        commit('setPagesTotal',['search',parseInt(res.headers['x-wp-totalpages'])]);
        commit('setPagesCurr',parseInt(res.headers['x-wp-totalpages']));
        commit('setPosts',['search',res.data]);
      })
    },
    randomPost({commit,dispatch}) {
       Axios.get('http://ecos.ec/wp-json/wp/v2/any').then(res=>{
        commit('setPagesCurr',null);
        commit('clearSearch');
        dispatch('selectPost',res.data)
        Router.push({path:'/random/'+res.data.slug});
      })
    },
    initPosts({commit,state},type){
      commit('setPosts',['search',null]);
      let typeFilter='';
      if(type != 'all') {
        typeFilter = '&filter[category_name]='+type;
      };
      if(state.pagesTotal[type]){ //stored
        //console.log('local call')
        //commit('setPagesTotal',[state.pagesTotal[type]]);
        commit('setPagesCurr',state.pagesTotal[type]);
        commit('setPosts',[type]);
        return;
      };
      var promise = new Promise(resolve => {
        Axios.get('http://ecos.ec/wp-json/wp/v2/posts/?page=1'+typeFilter).then(res=>{
          //console.log('http call')
          let posts = [];
          if(type == 'all') {
            let i = 0;
            res.data.map(post=>{
              let newPost = JSON.parse(JSON.stringify(post));
              newPost.category_slug = 'all';
              posts.push(newPost);
              i++;
            })
          }
          else {
            posts = res.data;
          }
          commit('setPagesTotal',[type,parseInt(res.headers['x-wp-totalpages'])]);
          commit('setPagesCurr',parseInt(res.headers['x-wp-totalpages']));
          commit('setPosts',[type,posts]);
          resolve(posts);
        })
        .catch(err=>console.log(err))
      })
      loader(promise,'#post_list');
    },
    fetchPage({commit,state},[type,page,searchTerm]){
      let typeFilter='';
      if(type != 'all') {
        typeFilter = '&filter[category_name]='+type;
      };
      let endpoint;
      if(searchTerm) {
        if(searchTerm.search('autor:')>-1) {
          endpoint = '?filter[author_name]='+searchTerm.split(':')[1].trim()+'&page='+page;
        }
        else {
          endpoint = '?search='+searchTerm+'&page='+page;
        }
      }
      else {
        endpoint = '?page='+page+typeFilter;
      }
      if(!state.posts[type][state.pagesCurr]) { // http
        var promise = new Promise(resolve=>{
          Axios.get('http://ecos.ec/wp-json/wp/v2/posts/'+endpoint).then(res=>{
            let posts = [];
            if(type == 'all') {
              posts = res.data.map(post=>{
                post.category_slug = 'all';
                return post;
              })
            }
            else {
              posts = res.data;
            }
            //console.log('http posts')
            commit('setPosts',[type,posts]);
            resolve(posts);
          })
        });
        loader(promise,'#post_list')
      }
      else {
        //console.log('stored')
        commit('setPosts',[type]);
      }
    },
    changePagesCurr({commit,state,dispatch},[type,dir,searchTerm]) {
      let queryPage = state.pagesTotal[type]-state.pagesCurr-dir+1;
      let currPage = state.pagesCurr+dir;
      if(dir>1) {
        queryPage = 1;
        currPage = dir;
      }
      commit('setPagesCurr',currPage);
      dispatch('fetchPage',[type,queryPage,searchTerm]);
    },

    selectPost({commit,state},post) {
      commit('setPostsSelected',post)
    },
    selectPostBySlug({commit,state},[slug,type]) {
      let localPost = false;
      if(type) {
        if(state.posts[type].length > 0) {
          for(let i = 0; i<state.posts[type].length;i++) {
            if(state.posts[type][i]) {
              state.posts[type][i].map(post=>{
                if(slug == post.slug) {
                  localPost = true;
                  //console.log('local post')
                  commit('setPostsSelected',post);
                  return;
                }
              });
            }
          }
        }
      }
      if(localPost) {
        return;
      }
      var promise = new Promise(resolve=>{
        Axios.get('http://ecos.ec/wp-json/wp/v2/posts/?filter[name]='+slug).then(res=>{
          resolve(true)
          commit('setPostsSelected',res.data[0]);
        })
      });
      loader(promise,'#main_post')
    }
  },
  getters: {
    getPosts(state,page) {
      return state.posts
    },
    getPostsSelected(state) {
      return state.postsSelected
    },
    getPagesTotal(state) {
      return state.pagesTotal
    },
    getPagesCurr(state) {
      return state.pagesCurr
    },
    getSearchTerm(state) {
      return state.searchTerm;
    }
  }
})



// WEBPACK FOOTER //
// ./src/store.js